import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { UiTooltip } from '@shared/components/ui';

@Component({
  selector: 'app-card-estadistico',
  imports: [UiTooltip],
  templateUrl: './card-estadistico.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './card-estadistico.css',
})
export class CardEstadistico {
  icono = input.required<string>();
  titulo = input.required<string>();
  valor = input.required<string>();
  color = input.required<'blue' | 'green' | 'yellow' | 'red' | 'purple'>();
  tooltip = input<string | null>(null);
}
